import { AutoComplete } from "antd";
import React, { useRef, useState } from "react";
import { useEffect } from "react";

const AutoSearchInput = ({
  onSearch,
  options,
  fieldName,
  setSelectedValue,
  placeholder,
  onChange,
  selectedValue,
}) => {
  const ref = useRef();
  const [value, setValue] = useState(selectedValue);

  useEffect(() => {
    setValue(selectedValue);
  }, [selectedValue])

  const handleSelect = (data) => {
    setSelectedValue(data);
    setValue(data);
  };

  const handleChange = (val) => {
    if (typeof onChange === "function") {
      onChange();
    }
    setValue(val);
  }

  return (
    <>
      <div ref={ref}>
        <AutoComplete
          className="auto-search"
          onSearch={(val) => onSearch(fieldName, val)}
          onSelect={handleSelect}
          onChange={handleChange}
          allowClear={false}
          options={options}
          placeholder={placeholder}
          value={value}
          getPopupContainer={() => ref.current}
        />
      </div>
    </>
  );
};

export default AutoSearchInput;
